module.exports = __webpack_public_path__ + "static/media/exercise-example-4.768dd521.png";